export const MESSAGE_CONSTANTS: any = {
  //* Order page *//
  LandingPage: {
    ALC_BDM: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    Residential_Manager: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    TM_DM: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    SVP_RVP: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    SALESPERSON_NONIHOUSE: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    SALESOPS: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    SINGLE_ACCOUNT_CUSTOMER: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    MULTI_ACCOUNT_CUSTOMER: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    CSR: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    Commercial: {
      headerText: "Welcome",
      bodyText: "Loading your customized dashboard...",
      barText: "please wait...",
    },
    productCatalog: {
      headerText: "Welcome",
      bodyText: "Loading Product Catalog...",
      barText: "please wait...",
    },
  },
  plp: {
    headerText: "Products",
    bodyText: "Loading Products!",
    barText: "Loading...",
  },

  pdp: {
    pdpDetails: {
      headerText: "Product",
      bodyText: "Loading Product Details!",
      barText: "Please wait...",
    },
    checkAvailability: {
      headerText: "Checking Availability",
      bodyText: "Processing!",
      barText: "Please wait...",
    },
    addToCart: {
      headerText: "Processing",
      bodyText: "Adding to Cart!",
      barText: "Please wait...",
    },
    onShippingOptionSubmit: {
      headerText: "Processing",
      bodyText: "Shipping options updating!",
      barText: "Please wait...",
    },
    createQuote: {
      headerText: "Processing",
      bodyText: "Creating Quote!",
      barText: "Please wait...",
    },
    checkForItemAddedinCart: {
      headerText: "Processing",
      bodyText: "Checking for item added in cart",
      barText: "Please wait...",
    },
    getInventoryStatus: {
      headerText: "Processing",
      bodyText: "Checking for inventory status",
      barText: "Please wait...",
    },
    validateShipViaAddress: {
      headerText: "Processing",
      bodyText: "validating Ship Via Address",
      barText: "Please wait...",
    },
    getAddresses: {
      headerText: "Account",
      bodyText: "Fetching Addressess!",
      barText: "Please wait...",
    },
    getShippingOptions: {
      headerText: "Shippping Options",
      bodyText: "Fetching Shippping Options!",
      barText: "Please wait...",
    },
    validateAddress: {
      headerText: "Validate",
      bodyText: "Validating Address!",
      barText: "Please wait...",
    },
    validateShippingOptions: {
      headerText: "Validate",
      bodyText: "Validating Shipping Options!",
      barText: "Please wait...",
    },
    validateShipVia: {
      headerText: "Validate",
      bodyText: "Validating Shipvia!",
      barText: "Please wait...",
    },
    atpCheck: {
      headerText: "ATP Check",
      bodyText: "Fetching Solutions!",
      barText: "Please wait...",
    },
    getAccessories: {
      headerText: "Accessories",
      bodyText: "Fetching Accessories!",
      barText: "Please wait...",
    },
    addToQuote: {
      headerText: "Add To Quote",
      bodyText: "Adding to Quote!",
      barText: "Please wait...",
    },
    getAllSamples: {
      headerText: "Order Sample",
      bodyText: "Loading Order samples!",
      barText: "Please wait...",
    },
    removeCart: {
      headerText: "Remove",
      bodyText: "Removing Cart!",
      barText: "Please wait...",
    },
    samplesInventoryCheck: {
      headerText: "Samples Inventory",
      bodyText: "Checking Samples Inventory! ",
      barText: "Please wait...",
    },
    getCart: {
      headerText: "Cart",
      bodyText: "Loading Cart!",
      barText: "Please wait...",
    },
    updateCart: {
      headerText: "Cart",
      bodyText: "Updating Cart!",
      barText: "Please wait...",
    },
    removeItemFromCart: {
      headerText: "Cart",
      bodyText: "Removing Item!",
      barText: "Please wait...",
    },
    cancelCart: {
      headerText: "Cart",
      bodyText: "Cancelling Cart!",
      barText: "Please wait...",
    },
    placeOrder: {
      headerText: "Cart",
      bodyText: "Placing Order!",
      barText: "Please wait...",
    },
    validateShipperAccount: {
      headerText: "Cart",
      bodyText: "Validating Shipper Account!",
      barText: "Please wait...",
    },
    updateSmallParcelFields: {
      headerText: "Cart",
      bodyText: "Updating SmallParcel Fields!",
      barText: "Please wait...",
    },
    viewPdf: {
      headerText: "View PDF",
      bodyText: "Generating PDF!",
      barText: "Please wait...",
    },
    preparing: {
      headerText: "Processing",
      bodyText: "Processing data",
      barText: "Please wait...",
    },
    emailsend: {
      headerText: "Share",
      bodyText: "Sharing Via Email",
      barText: "Please wait...",
    },
    validateCartForSmallParcel: {
      headerText: "Processing",
      bodyText: "Validating Cart For SmallParcel!",
      barText: "Please wait...",
    },
    orderReview: {
      headerText: "Processing",
      bodyText: "Proceeding to Order Review...",
      barText: "Please wait...",
    },
    validatePO: {
      headerText: "Processing",
      bodyText: "Validating PO!",
      barText: "Please wait...",
    },
    checkout: {
      headerText: "Processing",
      bodyText: "Proceeding to Checkout..",
      barText: "Please wait...",
    },
    cartProcessing: {
      headerText: "Processing",
      bodyText: "Processing...",
      barText: "Please wait...",
    },
    getBuilderInfo: {
      headerText: "Builder",
      bodyText: "Loading Builder Info!",
      barText: "Please wait...",
    },
    getBuilderDivision: {
      headerText: "Builder",
      bodyText: "Loading Builder Division!",
      barText: "Please wait...",
    },
    getBuilderSubdivision: {
      headerText: "Builder",
      bodyText: "Loading Builder Sub Division!",
      barText: "Please wait...",
    },
    submitBuilder: {
      headerText: "Builder",
      bodyText: "Submitting Builder Details!",
      barText: "Please wait...",
    },
    getQuote: {
      headerText: "Quote",
      bodyText: "Loading Quote!",
      barText: "Please wait...",
    },
    removeItemFromQuote: {
      headerText: "Quote",
      bodyText: "Removing Item!",
      barText: "Please wait...",
    },
    cancelQuote: {
      headerText: "Quote",
      bodyText: "Cancelling Quote!",
      barText: "Please wait...",
    },
    submitQuote: {
      headerText: "Quote",
      bodyText: "Submitting Quote!",
      barText: "Please wait...",
    },
    placeReserve: {
      headerText: "Reserve",
      bodyText: "Placing Reserve!",
      barText: "Please wait...",
    },
    getReservesList: {
      headerText: "Reserves",
      bodyText: "Loading Reserves!",
      barText: "Please wait...",
    },
    reserveDetails: {
      headerText: "Reserve",
      bodyText: "Loading Reserve Details!",
      barText: "Please wait...",
    },
    cancelReserve: {
      headerText: "Reserve",
      bodyText: "Cancelling Reserve!",
      barText: "Please wait...",
    },
    extendReserve: {
      headerText: "Reserve",
      bodyText: "Extending Reserve!",
      barText: "Please wait...",
    },
    fetchingSolutions: {
      headerText: "Solutions",
      bodyText: "Fetching Solutions!",
      barText: "Please wait...",
    },
    viewBudget: {
      headerText: "Budget",
      bodyText: "Loading budget data",
      barText: "Please wait...",
    },
  },

  //* Order page *//
  orderPage: {
    headerText: "Orders",
    bodyText: "Loading Orders!",
    barText: "Loading...",
  },
  //* Order detail Page *//
  orderDetails: {
    getOrderIdDetails: {
      headerText: "Order",
      bodyText: "Loading Order History!",
      barText: "Loading...",
    },
    getCAMSOrderIdDetails: {
      headerText: "CAMS Order",
      bodyText: "Loading CAMS ORDER DETAILS!",
      barText: "Loading...",
    },
    viewPdf: {
      headerText: "View PDF",
      bodyText: "Generating PDF!",
      barText: "Please wait...",
    },
    printOrder: {
      headerText: "Print Order",
      bodyText: "Generating Order Print!",
      barText: "Please wait...",
    },
    preparing: {
      headerText: "Processing",
      bodyText: "Processing data",
      barText: "Please wait...",
    },
    emailsend: {
      headerText: "Share",
      bodyText: "Sharing Via Email",
      barText: "Please wait...",
    },
    updateOrderDetails: {
      headerText: "Order",
      bodyText: "Updating order details!",
      barText: "Loading...",
    },
    cancelOrderOrLine: {
      headerText: "Order",
      bodyText: "Cancelling Order!",
      barText: "Loading...",
    },
    viewOrderUpdates: {
      headerText: "Order",
      bodyText: "Loading view order updates!",
      barText: "Loading...",
    },
    addNewLineOrder: {
      headerText: "Order",
      bodyText: "Adding new line to Order!",
      barText: "Loading...",
    },
  },
cloneOrders:{
  loadingAccounts: {
    headerText: "Clone A Sample Order",
    bodyText: "Loading Accounts",
    barText: "Please wait...",
  },

    cloneOrdersValidation:{
    headerText: "Validations",
    bodyText: "Validating Clone Order",
    barText: "Please wait...",
    }
  
},
  pricing: {
    download: {
      headerText: "Price Download",
      bodyText: "Exporting current pricing in Excel CSV format!",
      barText: "Downloading...",
    },
    search_download_pricing: {
      search: {
        headerText: "Search Pricing",
        bodyText: "Searching customized pricing!",
        barText: "Please wait...",
      },
      sort: {
        headerText: "Sorting",
        bodyText: "Sorting by select column!",
        barText: "Please wait...",
      },
      download: {
        headerText: "Price Download",
        bodyText: "Exporting current pricing in  {type} format!",
        barText: "Downloading...",
      },
      emailsend: {
        headerText: "Email",
        bodyText: "Sending Email in {type} format",
        barText: "Please wait...",
      },
      preparing: {
        headerText: "Processing",
        bodyText: "Processing data in {type} format",
        barText: "Please wait...",
      },
    },
    shippingAddress: {
      headerText: "Shipping Address",
      bodyText: "Fetching shipping addresses",
      barText: "Please wait...",
    },
  },
  claims: {
    claimHistory: {
      headerText: "Claims",
      bodyText: "Loading Claims!",
      barText: "Loading...",
    },
    claimDetails: {
      headerText: "Claim",
      bodyText: "Loading Claim!",
      barText: "Loading...",
    },
    createClaim: {
      headerText: "Claims",
      bodyText: "Creating Claim!",
      barText: "Loading...",
    },
    claimUpdate: {
      headerText: "Claim",
      bodyText: "Adding Claim!",
      barText: "Loading...",
    },
    draft: {
      headerText: "Draft",
      bodyText: "Saving as draft!",
      barText: "Please wait...",
    },
    submit: {
      headerText: "Claims",
      bodyText: "Submitting Claim!",
      barText: "Please wait...",
    },
    invoiceSearch: {
      headerText: "Invoices",
      bodyText: "Loading  Invoices!",
      barText: "Please wait...",
    },
    downloadingPdf: {
      headerText: "View PDF",
      bodyText: "Fetching PDF!",
      barText: "Please wait...",
    },
    shipToAddress: {
      headerText: "Invoices",
      bodyText: "Loading ShipToAddresses!",
      barText: "Please wait...",
    },
    openClaims: {
      headerText: "Open Claims",
      bodyText: "Loading Open Claims!",
      barText: "Please wait...",
    },
    invoiceLines: {
      headerText: "Invoice Lines",
      bodyText: "Loading Invoice Lines!",
      barText: "Please wait...",
    },
    claimsApprovalHistory: {
      headerText: "Claims Approval",
      bodyText: "Loading Claims!",
      barText: "Loading...",
    },
    claimApprovalDetails: {
      headerText: "Claim Approval",
      bodyText: "Loading Claim Approval!",
      barText: "Loading...",
    },
    claimApprovalUpdate: {
      headerText: "Claim Approval",
      bodyText: "Updating Claim Approval!",
      barText: "Loading...",
    },
    fileDownload: {
      headerText: "Download",
      bodyText: "Downloading File!",
      barText: "Loading...",
    },
    addDocument:{
      headerText: "File Attachment",
      bodyText: "File Uploading!",
      barText: "Please wait...",
    },
    claimConfirmation:{
      headerText: "Claim Confirmation",
      bodyText: "Fetching Confirmed Details!",
      barText: "Loading...",
    }
  },
  quotes: {
    QuoteList: {
      headerText: "Quotes",
      bodyText: "Loading Quotes!",
      barText: "Please wait...",
    },
    QuoteDetails: {
      checkout: {
        headerText: "Checkout",
        bodyText: "Proceeding to Checkout",
        barText: "please wait...",
      },
      getData: {
        headerText: "Quote Details",
        bodyText: "Loading Quote Details",
        barText: "please wait...",
      },
      viewPdf: {
        headerText: "View Pdf",
        bodyText: "Generating PDF!",
        barText: "please wait...",
      },
      emailsend: {
        headerText: "Share",
        bodyText: "Sharing Via Email",
        barText: "Please wait...",
      },
      preparing: {
        headerText: "Processing",
        bodyText: "Processing data",
        barText: "Please wait...",
      },
      potentialview: {
        headerText: "review potential",
        bodyText: "Fetching review potential",
        barText: "Please wait...",
      },
      cancel: {
        headerText: "Cancel Quote",
        bodyText: "Canceling Quote",
        barText: "Please wait...",
      },
      reject: {
        headerText: "Reject Quote",
        bodyText: "Rejecting Quote",
        barText: "Please wait...",
      },
      getAccessoryDetails: {
        headerText: "Accessory Details",
        bodyText: "Fetching Accessories",
        barText: "Please wait...",
      },
      addProduct: {
        headerText: "Processing",
        bodyText: "Adding your product",
        barText: "Please wait...",
      },
      convertToOrder: {
        headerText: "Processing",
        bodyText: "Processing with your product",
        barText: "Please wait...",
      },
      addToQuote: {
        headerText: "Quote",
        bodyText: "Adding To Quote",
        barText: "Please wait...",
      },
      removeEntyFromQuote: {
        headerText: "Remove Entry",
        bodyText: "Removing Entry From Quote",
        barText: "Please wait...",
      },
      addToCart: {
        headerText: "Add To Cart",
        bodyText: "Adding To Cart",
        barText: "Please wait...",
      },
      fetchingShippingAddress: {
        headerText: "Shipping Address",
        bodyText: "Fetching Shipping Address",
        barText: "Please wait...",
      },
      fetchingShippingOptions: {
        headerText: "Shipping Options",
        bodyText: "Fetching Shipping Options",
        barText: "Please wait...",
      },
      validateShippingOptions: {
        headerText: "Shipping Options",
        bodyText: "Validating Shipping Options",
        barText: "Please wait...",
      },
      updateShippingAddress: {
        headerText: "Shipping Address",
        bodyText: "Updating Shipping Address",
        barText: "Please wait...",
      },
      saveQuantity: {
        headerText: "Quote",
        bodyText: "Saving Quantity",
        barText: "Please wait...",
      },
    },
  },
  finance: {
    accountStatements: {
      headerText: "Account Statements",
      bodyText: "Loading Account Statements!",
      barText: "Loading...",
    },
    fetchpdf: {
      headerText: "PDF",
      bodyText: "Fetching pdf",
      barText: "Loading...",
    },
    accountStatementDetails: {
      headerText: "Account Statements",
      bodyText: "Loading Account Statement Details!",
      barText: "Loading...",
    },
    invoicesList: {
      headerText: "INVOICES",
      bodyText: "Loading Invoices!",
      barText: "Loading...",
    },
    onlinePaymentHistory: {
      headerText: "Online Payments",
      bodyText: "Loading Online Payments History!",
      barText: "Loading...",
    },
    recentPaymentHistory: {
      headerText: "Recent Payments",
      bodyText: "Loading Recent Payments History!",
      barText: "Loading...",
    },
    // scheduledPaymentHistory:{
    //   headerText: "Online Payments",
    //     bodyText: "Loading Scheduled Payments History!",
    //     barText: "Loading...",
    // },
    billBaySignUpList: {
      headerText: "Bill Pay Sign Up",
      bodyText: "Loading Receiver Email List!",
      barText: "Loading...",
    },
    billBaySignUp: {
      headerText: "Bill Pay Sign Up",
      bodyText: "Submitting Bill Pay Sign Up!",
      barText: "Loading...",
    },
    downloadingPdf: {
      headerText: "View PDF",
      bodyText: "Fetching PDF !",
      barText: "Please wait...",
    },
    makeAPaymentList: {
      headerText: "MAKE A PAYMENT",
      bodyText: "Fetching Payment List!",
      barText: "Please wait...",
    },
    bankAccountList: {
      headerText: "MAKE A PAYMENT",
      bodyText: "Fetching Bank Accounts List!",
      barText: "Please wait...",
    },
    scheduleYayment: {
      headerText: "MAKE A PAYMENT",
      bodyText: "Scheduling Payment!",
      barText: "Please wait...",
    },
    suspendPayment: {
      headerText: "MAKE A PAYMENT",
      bodyText: "Suspending Payment!",
      barText: "Please wait...",
    },
    getCreditMemos: {
      headerText: "Credit Memos",
      bodyText: "Loading Credit Memos!",
      barText: "Please wait...",
    },
    downloadCreditMemos: {
      headerText: "Credit Memos",
      bodyText: "Downloading Credit Memos!",
      barText: "Please wait...",
    },
    getCreditMemoPdf: {
      headerText: "Credit Memos",
      bodyText: "Fetching PDF!",
      barText: "Please wait...",
    },
  },

  companyModule: {
    manageUser: {
      headerText: "Users",
      bodyText: "Fetching users list!",
      barText: "Please wait...",
    },
    userDetail: {
      headerText: "User Detail",
      bodyText: "Fetching user details!",
      barText: "Please wait...",
    },
    updateUser: {
      headerText: "User Update",
      bodyText: "Updating user details!",
      barText: "Please wait...",
    },
    addUser: {
      headerText: "add user",
      bodyText: "Adding  new user!",
      barText: "Please wait...",
    },
    enable: {
      headerText: "Enabling",
      bodyText: "Enabling user!",
      barText: "Please wait...",
    },
    disable: {
      headerText: "Disable",
      bodyText: "Disabling user!",
      barText: "Please wait...",
    },
  },
  asmAbility: {
    startSession: {
      headerText: "ASM",
      bodyText: "Start Session!",
      barText: "Please wait...",
    },
    endSession: {
      headerText: "ASM",
      bodyText: "Stop Session!",
      barText: "Please wait...",
    },
  },
  myProfile: {
    updateProfile: {
      headerText: "Profile Update",
      bodyText: "Updating profile!",
      barText: "Please wait...",
    },
    shippingaddress: {
      headerText: "Shipping Address",
      bodyText: "Fetching shipping addresses",
      barText: "Please wait...",
    },
    updateShippingAddress: {
      headerText: "Processing",
      bodyText: "Shipping options updating!",
      barText: "Please wait...",
    },
    notifications: {
      headerText: "Processing",
      bodyText: "Notification preferences updating!",
      barText: "Please wait...",
    },
    defaultFrontStore: {
      headerText: "Processing",
      bodyText: "Updating default storefront!",
      barText: "Please wait...",
    },
  },
  accountSearch: {
    accountSearch: {
      headerText: "Accounts",
      bodyText: "Fetching Accounts!",
      barText: "Please wait...",
    },
    childHierarchy: {
      headerText: "Hierarchy",
      bodyText: "Loading Child Hierarchy!",
      barText: "Please wait...",
    },
    salesHierarchy: {
      headerText: "Hierarchy",
      bodyText: "Loading Sales Hierarchy!",
      barText: "Please wait...",
    },
    navigateToDhashbord: {
      headerText: "Navigate",
      bodyText: "Navigating to Dashboard!",
      barText: "Please wait...",
    },
    passKeyValidate: {
      headerText: "Validation",
      bodyText: "Validating Pass Key!",
      barText: "Please wait...",
    },
    navigateToQuote: {
      headerText: "Navigate",
      bodyText: "Navigating to Quote!",
      barText: "Please wait...",
    },
    navigateToOrder: {
      headerText: "Navigate",
      bodyText: "Navigating to Order!",
      barText: "Please wait...",
    },
    savingAccounts: {
      headerText: "Accounts",
      bodyText: "Saving Accounts!",
      barText: "Please wait...",
    },
    updateAccount: {
      headerText: "Account",
      bodyText: "Updating Account!",
      barText: "Please wait...",
    }
  },
  mohawkSalesTeam: {
    getSalesTeamList: {
      headerText: " Sales Team",
      bodyText: "Fetching Mohawk Sales Team List!",
      barText: "Please wait...",
    },
  },
  compareProduct: {
    compare: {
      headerText: "Loading",
      bodyText: "Loading Compare Products!",
      barText: "Please wait...",
    },
    viewpdf: {
      headerText: "View PDF",
      bodyText: "Generating PDF!",
      barText: "Please wait...",
    },
  },
};
